import {
  APPLICABLE_RULE,
  DOCUMENT_TYPE,
  IMPORTANT_RULE,
  SELFIE_TYPE
} from "../../constants";

export function translateDocumentType(key) {
  switch (key) {
    case DOCUMENT_TYPE.PASSPORT:
      return this.$t(
        "companyProcedures.acceptedDocuments.documentType.passport"
      );
    case DOCUMENT_TYPE.ID_CARD:
      return this.$t("companyProcedures.acceptedDocuments.documentType.idCard");
    case DOCUMENT_TYPE.DRIVING_LICENSE:
      return this.$t(
        "companyProcedures.acceptedDocuments.documentType.driverLicense"
      );
    case DOCUMENT_TYPE.LOCAL_PASSPORT:
      return this.$t(
        "companyProcedures.acceptedDocuments.documentType.localPassport"
      );
    case DOCUMENT_TYPE.RESIDENCE_PERMIT:
      return this.$t(
        "companyProcedures.acceptedDocuments.documentType.residencePermit"
      );
    default:
      return key;
  }
}

export function translateDocumentRule(key) {
  switch (key) {
    case APPLICABLE_RULE.MRZ_REQUIRED:
      return this.$t(
        "companyProcedures.acceptedDocuments.applicableRule.mrzRequired"
      );
    case APPLICABLE_RULE.BACK_SIDE_REQUIRED:
      return this.$t(
        "companyProcedures.acceptedDocuments.applicableRule.backSideRequired"
      );
    case APPLICABLE_RULE.ONLY_SPECIFIC_COUNTRIES_ACCEPTABLE:
      return this.$t(
        "companyProcedures.acceptedDocuments.applicableRule.onlySpecificCountriesAcceptable"
      );
    case APPLICABLE_RULE.BOTH_SIDES_REQUIRED:
      return this.$t(
        "companyProcedures.acceptedDocuments.applicableRule.bothSidesRequired"
      );
    case APPLICABLE_RULE.PROVISIONAL_OR_LEARNER_DL_ACCEPTED:
      return this.$t(
        "companyProcedures.acceptedDocuments.applicableRule.provisionalOrLearnerAccepted"
      );
    case APPLICABLE_RULE.ACCEPT_PERMANENTLY:
      return this.$t(
        "companyProcedures.acceptedDocuments.applicableRule.acceptPermanent"
      );
    case APPLICABLE_RULE.ACCEPT_TEMPORARY:
      return this.$t(
        "companyProcedures.acceptedDocuments.applicableRule.acceptTemporary"
      );
    default:
      return key;
  }
}

export function translateSelfieType(key) {
  switch (key) {
    case SELFIE_TYPE.MOVING_SELFIE_REQUIRED:
      return this.$t(
        "companyProcedures.selfieSettings.selfieType.movingSelfieRequired"
      );
    case SELFIE_TYPE.PHOTO_STANDARD_NOT_FROM_DOCUMENT:
      return this.$t(
        "companyProcedures.selfieSettings.selfieType.photoStandardNotFromDocument"
      );
    case SELFIE_TYPE.PHOTO_STANDARD_HOLDING_DOCUMENT:
      return this.$t(
        "companyProcedures.selfieSettings.selfieType.photoStandardHoldingDocument"
      );
    case SELFIE_TYPE.NO_REQUIRED:
      return this.$t("companyProcedures.selfieSettings.selfieType.noRequired");
    default:
      return key;
  }
}

export function translateImportantRule(key) {
  switch (key) {
    case IMPORTANT_RULE.HAS_PROHIBITED_COUNTRIES:
      return this.$t(
        "companyProcedures.important.rules.hasProhibitedCountries"
      );
    case IMPORTANT_RULE.HAS_PROHIBITED_NATIONALITIES:
      return this.$t(
        "companyProcedures.important.rules.hasProhibitedNationalities"
      );
    case IMPORTANT_RULE.ACCEPT_EXPIRATION_DATE_TODAY:
      return this.$t(
        "companyProcedures.important.rules.acceptExpirationDateToday"
      );
    case IMPORTANT_RULE.NO_SCANNED_PICS_BAD_MEDIA_FORMAT:
      return this.$t(
        "companyProcedures.important.rules.noScannedPicsBadMediaFormat"
      );
    case IMPORTANT_RULE.NO_SCANNED_PICS_FRAUD_ATTEMPT:
      return this.$t(
        "companyProcedures.important.rules.noScannedPicsFraudAttempt"
      );
    case IMPORTANT_RULE.NO_PRINT_SCREENS:
      return this.$t("companyProcedures.important.rules.noPrintscreens");
    case IMPORTANT_RULE.NO_SCREEN_CAPTURE:
      return this.$t("companyProcedures.important.rules.noScreenCapture");
    case IMPORTANT_RULE.NO_PRINT_SCREENS_CAPTURE:
      return this.$t("companyProcedures.important.rules.noPrintScreensCapture");
    case IMPORTANT_RULE.NO_BLACK_OR_WHITE_PICTURES:
      return this.$t(
        "companyProcedures.important.rules.noBlackOrWhitePictures"
      );
    case IMPORTANT_RULE.ADDITIONAL_REGISTRATION_VALIDATION_REQUIRED:
      return this.$t(
        "companyProcedures.important.rules.additionalRegistrationValidationRequired"
      );
    default:
      return key;
  }
}

export function isCountryInTheList(countryCode, list) {
  return !!list?.find(country => country === countryCode);
}

export function isEmpty(item) {
  return item == null || item === "";
}

export function getSelectSize(itemsLength) {
  if (itemsLength < 2) {
    return 2;
  }

  return itemsLength;
}
